import React from 'react';
import Loading from './loading';
import Auth from './auth';
import { Outlet, Navigate } from 'react-router-dom';
import Root from '@/components/Root';

const Home = React.lazy(() => import(/* webpackChunkName: "home" */ '@/containers/Home'));
const NotFound = React.lazy(() => import(/* webpackChunkName: "not-found" */ '@/containers/NotFound'));
const Login = React.lazy(() => import(/* webpackChunkName: "login" */ '@/containers/Login'));
const Shop = React.lazy(() => import(/* webpackChunkName: "shop" */ '@/containers/Shop'));
const goodsCreate = React.lazy(() => import(/* webpackChunkName: "goods-create" */ '@/containers/goods/Create'));
const goodsList = React.lazy(() => import(/* webpackChunkName: "goods-list" */ '@/containers/goods/List'));
const ordersList = React.lazy(() => import(/* webpackChunkName: "orders-list" */ '@/containers/orders/List'));
const ReStockList = React.lazy(() => import(/* webpackChunkName: "restock-list" */ '@/containers/orders/ReStockList'));
const ReStockDetail = React.lazy(() => import(/* webpackChunkName: "restock-detail" */ '@/containers/orders/ReStockDetail'));
const orderDetail = React.lazy(() => import(/* webpackChunkName: "orders-detail" */ '@/containers/orders/Detail'));
const accountCenter = React.lazy(() => import(/* webpackChunkName: "account-center" */ '@/containers/AccountCenter'));
const Forget = React.lazy(() => import(/* webpackChunkName: "forget" */ '@/containers/Forget'));
const AllNotice = React.lazy(() => import(/* webpackChunkName: "notice" */ '@/containers/Notice/AllNotice'));

function Page(Component, useAuth) {
  return (
    <React.Suspense fallback={<Loading />}>
      <Auth useAuth={useAuth}>
        <Component />
      </Auth>
    </React.Suspense>
  );
}

const routes = [
  {
    path: '/',
    element: (
      <Root>
        <Outlet />
      </Root>
    ),
    children: [
      {
        path: '',
        element: <Navigate to="shop" replace />,
      },
      {
        path: '/shop',
        element: Page(Shop, true),
      },
      {
        path: '/goods_create',
        element: Page(goodsCreate, true),
      },
      {
        path: '/goods_List',
        element: Page(goodsList, true),
      },
      {
        path: '/order_List',
        element: Page(ordersList, true),
      },
      {
        path: '/restock_List',
        element: Page(ReStockList, true),
      },

      {
        path: '/account_center',
        element: Page(accountCenter, true),
      },
      {
        path: '/all_notice',
        element: Page(AllNotice, true),
      },
    ],
  },
  {
    path: '/login',
    element: Page(Login),
  },
  {
    path: '/forget',
    element: Page(Forget),
  },
  {
    path: '/order_detail',
    element: Page(orderDetail, true),
  },
  {
    path: '/restock_detail',
    element: Page(ReStockDetail, true),
  },
  {
    path: '*',
    element: Page(NotFound),
  },
];

export default routes;
